import { PureComputed } from 'knockout';
import WCCImage from 'models/attachments/image';
import { PhotosetConfig, PhotosetHiddenItemsConfig, PhotosetHiddenItemsState, PhotosetLayout } from './photoset.interfaces';

export default class Photoset {
    source: PureComputed<Array<WCCImage>>

    outerOffset: PureComputed<number>
    offset: PureComputed<number>
    colsCount: PureComputed<number>
    columnWidth: PureComputed<number>
    rowsCount: PureComputed<number>
    maxHeight: PureComputed<number>

    noUpscale: PureComputed<boolean>
    ignoreOrder: PureComputed<boolean>
    center: PureComputed<boolean>
    expand: PureComputed<boolean>

    layout: PureComputed<PhotosetLayout>

    hiddenItems: PhotosetHiddenItemsState

    noSingleImageCaption: PureComputed<boolean>

    constructor(config: PhotosetConfig) {
        this.source = ko.observable(config.source).unwrap().default(new Array<WCCImage>()).extend({ deferred: true });

        this.outerOffset = ko.observable(config.outerOffset).unwrap().default(0);
        this.offset = ko.observable(config.offset).unwrap().default(0);
        this.colsCount = ko.observable(config.colsCount).unwrap().default(2);
        this.columnWidth = ko.observable(config.columnWidth).unwrap().default(0);
        this.rowsCount = ko.observable(config.rowsCount).unwrap().default(2);
        this.maxHeight = ko.observable(config.maxHeight).unwrap().default(0);

        this.noUpscale = ko.observable(config.noUpscale).unwrap().default(false);
        this.ignoreOrder = ko.observable(config.ignoreOrder).unwrap().default(false);
        this.center = ko.observable(config.center).unwrap().default(true);
        this.expand = ko.observable(config.expand).unwrap().default(true);

        this.layout = ko.observable(config.layout).unwrap().default('fitColumn');        

        this.hiddenItems = this.buildHiddenItemsOptions(config.hiddenItems);

        this.noSingleImageCaption = ko.observable(config.noUpscale).unwrap().default(false);
    }

    private buildHiddenItemsOptions(config?: PhotosetHiddenItemsConfig): PhotosetHiddenItemsState {
        return {
            count: ko.observable(0),
            showCounter: ko.observable(config?.showCounter).unwrap().default(true)
        }
    }
}